import Alert from "@material-ui/lab/Alert";
import React from "react";
import PageSpinner from "../../../../../elements/spinner/PageSpinner";

import MaterialCheckbox from "../../../../../styles/materialCheckbox";
import { StyledCheckbox } from "../../../../../styles/styledTabsForm";

const CreateBalancesDialogList = ({
  t,
  serviceRelations,
  displayedOptions,
  balances,
  balanceData,
  updateBalanceData
}) => {

  if (!serviceRelations) {
    return <PageSpinner
      position="center"
      pt="60"
      pb="60"
    />;
  }

  if (!serviceRelations.length) {
    return <Alert severity="warning">
      {t("details.balancesForm.noServiceRelations")}
    </Alert>;
  }

  if (balances.length === serviceRelations.length) {
    return <Alert severity="success">
      {t("details.balancesForm.allBalancesCreated")}
    </Alert>;
  }

  if (!displayedOptions.length) {
    return <Alert severity="warning">
      {t("details.balancesForm.noSearchResults")}
    </Alert>;
  }

  return (
    <>
      {displayedOptions.map((relation, key) => {
        let balance = balances.find(balance => balance.currency.asset === relation.currency.asset);

        if (balance) {
          return (
            <></>
          );
        }

        return (
          <label
            className={`balances__row ${balanceData[relation.currency.asset] ? "balances_active" : ""}`}
            key={key}
            htmlFor={relation.currency.asset}
          >
            <div>
              {relation.currency.asset}
            </div>
            <div>
              <StyledCheckbox position="center">
                <MaterialCheckbox
                  type="checkbox"
                  name="applyTo"
                  id={relation.currency.asset}
                  onChange={(data) => updateBalanceData(data, relation.currency.asset)}
                  checked={balanceData[relation.currency.asset] ?? false}
                />
              </StyledCheckbox>
            </div>
          </label>
        );
      })}
    </>
  );
};

export default CreateBalancesDialogList;